var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 18,
    height: 19.92,
    transform: "translate(0 0)",
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2135",
    "data-name": "Groupe 2135",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2134",
    "data-name": "Groupe 2134",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_782",
    "data-name": "Trac\\xE9 782",
    d: "M15,14.08a2.912,2.912,0,0,0-1.96.77L5.91,10.7A3.274,3.274,0,0,0,6,10a3.274,3.274,0,0,0-.09-.7l7.05-4.11A2.993,2.993,0,1,0,12,3a3.274,3.274,0,0,0,.09.7L5.04,7.81a3,3,0,1,0,0,4.38l7.12,4.16a2.821,2.821,0,0,0-.08.65A2.92,2.92,0,1,0,15,14.08M15,2a1,1,0,1,1-1,1,1,1,0,0,1,1-1M3,11a1,1,0,1,1,1-1,1,1,0,0,1-1,1m12,7.02a1,1,0,1,1,1-1,1,1,0,0,1-1,1",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOutlined);
export default __webpack_public_path__ + "static/media/ShareOutlined.02e6562e1fd8669f852b4b1257d4b8ab.svg";
export { ForwardRef as ReactComponent };